// Please keep these in alphabetical order
export const paths = {
  adminDocuments: '/admin/documents',
  agingReports: '/aging-reports',
  area51: '/admin/area-51',
  attendance: '/attendance',
  authError: '/auth-error',
  authReturn: '/auth-return',
  billingSettings: '/billing/settings',
  calendar: '/calendar',
  completeSignup: '/complete-signup',
  migrationReport: '/admin/migration-report',
  devices: '/devices',
  documents: '/documents',
  enrolledFamilies: '/enrolled-families',
  enrollmentsAdmin: '/enrollments-admin',
  error: '/error',
  events: '/events',
  featureFlags: '/feature-flags',
  financialSummary: '/financial-summary',
  foodProgramClaims: '/food/claims',
  foodProgramClaimCreate: '/food/claims/new',
  foodProgramClaimUpdate: '/food/claims/:claimId',
  foodProgramMeals: '/food/meals',
  foodProgramMealCreate: '/food/meals/new',
  foodProgramMealUpdate: '/food/meals/:mealId',
  foodProgramMealRecordCreate: '/food/meals/record/new',
  foodProgramMenuPlanning: '/food/menus',
  foodProgramMenuPlanningUpdate: '/food/menus/edit/:date',
  foodProgramReports: '/food/reports',
  formsBuilder: '/forms',
  home: '/',
  impersonate: '/admin/impersonate/:organizationId',
  invoices: '/billing/invoices',
  invoiceEditConfirm: '/billing/invoice/confirm',
  invoiceEditDetails: '/billing/invoices/edit',
  invoiceEditStudents: '/billing/invoice/select',
  locations: '/locations',
  login: '/login',
  messages: '/messages',
  myRoles: '/my-roles',
  networks: '/admin/networks',
  parentHandbook: '/parent-handbook',
  // Add Families onboarding wizard. Registered under both the canonical
  // `/ccms/add-families` path (used by Nova / deep links) and the bare
  // `/add-families` alias so legacy moxit-web URLs keep working.
  addFamilies: '/ccms/add-families',
  addFamiliesAlias: '/add-families',
  parentsListing: '/family-contacts',
  profile: '/profile',
  providers: '/admin/providers',
  r404: '/404',
  r401: '/401',
  recurringPlans: '/billing/plans',
  recurringPlanEditDetails: '/billing/plans/edit',
  addToBilling: '/billing/plans/add-to-billing',
  rooms: '/rooms',
  setup: '/setup',
  signin: '/signin',
  signout: '/signout',
  signoutFull: '/signout-full',
  signup: '/signup/:networkId?',
  staff: '/staff',
  staffDetails: '/staff/:staffId',
  staffTimesheet: '/staff-timesheet',
  studentAdd: '/student-add',
  studentAddChild: '/student-add-child/:marketplaceChildId',
  studentEnrollment: '/enrollment/:studentId',
  studentEnrollmentSummary: '/enrollment-summary/:studentId',
  studentEnrollmentInvoice: '/enrollment-invoice/:studentId',
  students: '/students',
  studentsFilter: '/students/:filter?',
  // While /students/:studentId would be the recommended URL it gets masked by /students/:filter? rule and
  // it is not easy to replace it without reloading pages or the component of StudentList.
  studentDetails: '/student/:studentId',
  // Director-side "end this enrollment" page (replaces the modal that lived
  // on the student detail page). Handles the whole flow: unenroll date +
  // notice-days + reason + recurring plans to end + deposit + prorate math +
  // family script. `/success` variant is the post-submit family-script step.
  studentUnenroll: '/student/:studentId/unenroll',
  // Dashboard of enrolled students with a scheduled last day. Shows prorate
  // math, deposit credit, and net owed per student. Gated by the same
  // is-unenroll-v2-enabled LaunchDarkly flag as the unenroll form.
  unenrollments: '/unenrollments',
  studentsImport: '/import/students',
  systemNotifications: '/admin/system-notifications',
  timeSpaceCalculator: '/timespace-calculator',
  transactions: '/transactions',
  users: '/admin/users',
  verify: '/verify',
  welcome: '/welcome',
  appstore: '/appstore',
  learningBeyondPaper: '/appstore/learning-beyond-paper',
  kinderConnect: '/appstore/kinder-connect',
  openLedger: '/appstore/open-ledger',
  substituteTeachers: '/substitute-teachers',
  wonderschoolPhoneNumber: '/wonderschool-phone-number',
  businessCoachingSurvey: '/business-coaching-survey',
  checkInCheckOut: '/check-in-check-out',
  mealLogging: '/meal-logging',
  billingSignUp: '/billing-sign-up',
  tuitionPricingCoaching: '/tuition-pricing-coaching',
  annualTuitionIncreases: '/annual-tuition-increases',
  taxes: '/taxes',
  taxForms: '/billing/tax-forms',
  subsidyPrepayment: '/subsidy-prepayment',
  triShare: '/tri-share',
  debitCard: '/debit-card',
  earnInterest: '/earn-interest',
  insurance: '/insurance',
  payroll: '/payroll',
  whiteLabelWebsite: '/white-label-website',
  debug: '/debug',
  external: {
    aiPhone: '/admin/{marketplaceSchoolId}/ai-phone',
    apiLeads: '/firebase-api/schools/{marketplaceSchoolId}/leads',
    apiLead: '/firebase-api/schools/{marketplaceSchoolId}/leads/{leadId}',
    availabilitySurvey: '/admin/{marketplaceSchoolId}/availability-surveys',
    comparablePrograms: '/admin/{marketplaceSchoolId}/comparable-programs',
    credentials: '/admin/{marketplaceSchoolId}/settings/credentials',
    events: '/admin/{marketplaceSchoolId}/events',
    flyers: '/admin/{marketplaceSchoolId}/flyers',
    googleMyBusiness: '/admin/{marketplaceSchoolId}/google-my-business',
    groupMessage: '/admin/{marketplaceSchoolId}/group-message',
    helpCenter: '/hc/en-us/categories/4416555627287-Wonderschool-2-0-Support',
    interestedFamilies: '/admin/{marketplaceSchoolId}/interested',
    // Nova Interested List, the only list carrying Invite to Enroll (MP-7001).
    interestedList: '/ccms/interested-list',
    locationEdit: '/admin/{marketplaceSchoolId}/website/settings?edit=school',
    marketing: '/admin/{marketplaceSchoolId}/interested/marketing',
    marketingAnalytics: '/admin/{marketplaceSchoolId}/marketing/analytics',
    messages: '/admin/{marketplaceSchoolId}/messages/{channelId}',
    messaging: '/admin/{marketplaceSchoolId}/messaging/{channelId}',
    onboarding: '/onboarding',
    setupAssistant: '/ccms/setup-assistant',
    settings: '/admin/{marketplaceSchoolId}/settings',
    sharedLeads: '/ccms/shared-leads',
    subsidyPrepaymentNova: '/admin/{marketplaceSchoolId}/subsidy-prepayment',
    tuitionGenerator: '/admin/{marketplaceSchoolId}/tuition-generator',
    launchNova: '/admin/{marketplaceSchoolId}/launch',
    tours: '/director/admin/{marketplaceSchoolId}/combined-tours/calendar',
    tourRequests: '/director/admin/{marketplaceSchoolId}/combined-tours/requests',
    tuitionSettings: '/admin/{marketplaceSchoolId}/tuition',
    updateWebsite: '/admin/{marketplaceSchoolId}/website',
    viewWebsite: '/-{marketplaceSchoolId}',
    yelp: '/admin/{marketplaceSchoolId}/yelp',
  },
  headless: {
    updateWebsite: '/headless/{marketplaceSchoolId}/website',
    events: '/headless/{marketplaceSchoolId}/events',
    interestedFamilies: '/headless/{marketplaceSchoolId}/interested',
    locationEdit: '/admin/{marketplaceSchoolId}/website/settings?edit=school',
    marketing: '/headless/{marketplaceSchoolId}/interested/marketing',
    messages: '/headless/{marketplaceSchoolId}/messages/{channelId}',
    messaging: '/headless/{marketplaceSchoolId}/messaging/{channelId}',
    tours: '/headless/{marketplaceSchoolId}/interested/calendar',
    tourRequests: '/headless/{marketplaceSchoolId}/tours',
  },
  // These are legacy and should be deprecated at some point.
  billing: {
    hashes: {
      details: '#details',
      items: '#items',
      students: '#students',
      confirm: '#confirm',
    },
    plans: {
      list: '/billing/plans',
      edit: '/billing/plans/edit',
    },
    invoices: {
      list: '/billing/invoices',
      edit: '/billing/invoices/edit',
      reports: '/billing/invoices/reports',
    },
    reports: '/billing/reports',
    details: '/billing/invoice/details',
    items: '/billing/invoice/items',
    detailsRecurringHash: '#recurring-plans',
    select: '/billing/invoice/select',
    confirm: '/billing/invoice/confirm',
  },
  newStudentAdd: '/new-student-add',
  newStudentAddChild: '/new-student-add-child/:marketplaceChildId',
  wonderschoolApp: '/wonderschool-app',
};
